export function initUmami(): void {
  const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
  if (!websiteId) return;

  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://analytics.hooklink.net/script.js';
  script.dataset.websiteId = websiteId;
  document.head.appendChild(script);
}

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, string | number>) => void;
    };
  }
}

/**
 * Track a custom event in Umami.
 * Fires only if the Umami script is loaded.
 */
export function trackEvent(event: string, data?: Record<string, string | number>): void {
  window.umami?.track(event, data);
}

/**
 * Track an activation funnel event that should only fire once per user.
 * Uses localStorage to deduplicate.
 */
export function trackOnce(event: string, data?: Record<string, string | number>): void {
  const key = `umami_tracked_${event}`;
  if (localStorage.getItem(key)) return;
  trackEvent(event, data);
  localStorage.setItem(key, '1');
}
